<template>
  <div>
    <!--   配送单入金待确认 -->
    <baseBreadcrumb :page="$t('message.porderPayWaitConfirm')" :menu="$t('message.porder')" />
    <porderBaseTable :status="40" />
  </div>
</template>
<script>
import porderBaseTable from "@/components/porder/porderBaseTable/index";
export default {
  components: { porderBaseTable },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped></style>